import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getColorFromKey } from '../../../../util/helpers';

class Stage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getVerbValue(isPast = false) {
    const { value } = this.props;
    let stage = value;
    if (value === 'Won') {
      stage = isPast ? 'won' : 'win';
    } else if (value === 'Lost') {
      stage = isPast ? 'lost' : 'loss';
    } else if (value === 'No Decision') {
      stage = isPast ? 'pushed' : 'push';
    } else if (stage === 'Pending') {
      stage = isPast ? 'pending' : 'pending';
    }
    return stage;
  }

  getNounValue() {
    const { value } = this.props;
    let stage = value;
    if (value === 'Won') {
      stage = 'Win';
    } else if (value === 'Lost') {
      stage = 'Loss';
    } else if (value === 'No Decision') {
      stage = 'No Decision';
    } else if (stage === 'Pending') {
      stage = 'Pending';
    }
    return stage;
  }

  render() {
    const { value, type, isPast } = this.props;
    if (!value) {
      return null;
    }
    let comp = value;
    if (type === 'verb') {
      comp = this.getVerbValue(isPast);
    } else if (type === 'noun') {
      comp = this.getNounValue(isPast);
    }
    const color = getColorFromKey(value);
    comp = (<span style={{ color }}>{comp}</span>);

    return comp;
  }
}

Stage.propTypes = {
  value: PropTypes.string,
  type: PropTypes.oneOf(['verb', 'noun']),
  isPast: PropTypes.bool,
};

Stage.defaultProps = {
  value: null,
  type: 'verb',
  isPast: true,
};

export default Stage;
